import axios from '../js/ajax'

/** 微信h5获取静默授权url和非静默授权url */
export const getWechatPublicAuthorizationUrl = params => axios.postJson('/getWechatPublicAuthorizationUrl', params);

/** 微信h5登录 */
export const wechatH5AuthLogin = params => axios.post('/wechatH5AuthLogin', params);

/** 获取登录状态 */
export const getLoginStatus = params => axios.get('/getLoginStatus', params);
/** 发送验证码 */
export const sendCode = (params) => axios.post('/user/sendSmsValidateCode',params)
/** 绑定手机号 */
export const bindPhone = params => axios.post('/user/bindMobilePhone', params)
/** 获取用户绑定状态 */
export const getBindPhoneStatus = params =>  axios.get('/user/getBindMobilePhonePageStatus',params)
// 完成注册/登录时绑定手机号的流程
export const completeBindPhoneForRegister = (params) => axios.post('/user/completeBindPhoneForRegister', params)
/** 设置邀请码 */
export const setInvitCode = (params) => axios.post('/user/bindInvitationCode', params)
/** 获取登录状态 */
export const isLogin = ()=> axios.get('/getLoginStatus')
/** 检测用户是否已经绑定邀请码 */
export const isSetInvitCode = ()=> axios.get('/user/getInvitationCodeBindStatus')
// 拼多多判断用户的授权状态
export const judgePddAuthorizationStatus = () => axios.get('/product/judgePddAuthorizationStatus');
/** 获取用户信息 */
export const getUserInfo = () => axios.get('user/getInformation')
/** 获取用户信息 */
export const newLogin = (params) => axios.postJson('/loginForAllPlatform', params)
